import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexInvoiceFour',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const InvoicePageFour = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoice4/InvoicePageFour.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card3), { colClass: "container invoice-2" }, {
    default: _withCtx(() => [
      _createVNode(_unref(InvoicePageFour))
    ]),
    _: 1
  }))
}
}

})